import { render, staticRenderFns } from "./PdfDownloadFooter.vue?vue&type=template&id=cf9c64c4&scoped=true"
import script from "./PdfDownloadFooter.vue?vue&type=script&lang=js"
export * from "./PdfDownloadFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9c64c4",
  null
  
)

export default component.exports